import {API_BASE} from '../../apiConfig';

/**
 * Сетевой слой записи локального матча (движок записи — общий с обучением,
 * см. createTutorialReplayRecorder). Ответ отдается как есть — {status, data};
 * решает, повторять ли, сам рекордер. Сетевой сбой — отклоненный промис.
 *
 * Отправка идет не по таймеру, а раз в раунд (см. localMatchReplayMiddleware):
 * локальную партию ведет только клиент, и сервер о ней узнает пачками.
 */

const readJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};

export const localRunTransport = {
  /**
   * @param {Object} runContext - {finalRound, players} снимок состава партии:
   *   у локального матча нет лобби, и сервер знает о нем только это
   */
  async createRun(runContext, runId, actions = [], {keepalive = false} = {}) {
    const response = await fetch(`${API_BASE}/users/me/local-runs`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      // Создание при закрытии вкладки: запрос должен дойти и после выгрузки
      keepalive,
      body: JSON.stringify({
        runId,
        finalRound: runContext?.finalRound ?? null,
        players: runContext?.players || [],
        actions,
      }),
    });
    return {status: response.status, data: await readJsonSafely(response)};
  },

  async appendActions(matchId, body, {keepalive = false} = {}) {
    const response = await fetch(`${API_BASE}/users/me/local-runs/${encodeURIComponent(matchId)}/actions`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      keepalive,
      body: JSON.stringify(body),
    });
    return {status: response.status, data: await readJsonSafely(response)};
  },
};
